import { createContext } from 'react';

export interface ElementController {
  sideMenuRef: React.RefObject<HTMLTdsSideMenuElement | null>;
  enableSidebar: boolean;
  setEnableSidebar: React.Dispatch<React.SetStateAction<boolean>>;
  toggleMobileNav: () => void;
}

const ElementControllerContext = createContext<ElementController | null>(null);

export default ElementControllerContext;
